import { Component, OnInit } from '@angular/core';

// Se importa el CHANGELOG.md como string raw gracias a Webpack raw-loader o la config de Angular
// Usamos fetch para cargar el archivo desde assets
@Component({
  selector: 'app-changelog',
  templateUrl: './changelog.component.html',
  styleUrls: ['./changelog.component.scss'],
  standalone: false,
})
export class ChangelogComponent implements OnInit {
  public changelogMd = '';
  public cargando = true;

  async ngOnInit() {
    try {
      const res = await fetch('assets/CHANGELOG.md');
      this.changelogMd = await res.text();
    } catch {
      this.changelogMd = '*No se pudo cargar el changelog.*';
    } finally {
      this.cargando = false;
    }
  }
}
